import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const lodineDistributionRepository = RepositoryFactory.get(
  "lodineDistribution"
);

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setLodineDistribution(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadLodineDistribution(context, screenId) {
    const lodine = await lodineDistributionRepository.list(screenId);
    if (lodine.status < 300) {
      context.commit("setLodineDistribution", lodine.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
